import config from "../config";

let wheelId = 1;// Varsayılan değer
let wheelIdLoaded = false;
let wheelIdLoadingPromise = null;
let bonusProcess = '';
const baseHostname = window.location.host.split(".")[0];

const getKeys = async (body) => {
  if (typeof window.rh === 'undefined' || typeof window.rh.cr !== 'function') {
    return ['', ''];
  }
  try {
    return await Promise.race([
      window.rh.cr(body),
      new Promise((resolve) => setTimeout(() => resolve(['', '']), 5000))
    ]);
  } catch {
    return ['', ''];
  }
};

const loadWheelConfig = async () => {
  if (wheelIdLoadingPromise) {
    return wheelIdLoadingPromise;
  }
  

  wheelIdLoadingPromise = new Promise(async (resolve) => {
    try {
      let body = JSON.stringify({
        process_id: 'get-cark-config',
        user_id: baseHostname,
        recaptcha: "test"
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrlAdvanced}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });
      const data = await response.json();
      wheelId = data.spinWheelId;
      bonusProcess = data.requestProcess;
      wheelIdLoaded = true;
      resolve();
    } catch (error) {
      console.error('WheelConfig yüklenirken hata:', error);
      wheelIdLoaded = true; // Hata durumunda varsayılan değeri kullan
      resolve();
    }
  });

  return wheelIdLoadingPromise;
};

// Servis başlatıldığında config'i yükle
loadWheelConfig();

// wheelId kullanılan her servis için wrapper fonksiyon
const ensureWheelIdLoaded = async (callback) => {
  if (!wheelIdLoaded) {
    await loadWheelConfig();
  }
  return callback();
};

export const validateUser = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    if (!userId) {
      console.error('User ID bulunamadı');
      return null;
    }

    try {
      let body = JSON.stringify({
        process_id: 'get-user',
        user_id: userId,
        recaptcha: 'test'
      });
      let keys = await getKeys(body);
      const validationResponse = await fetch(`${config.apiBaseUrlAdvanced}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!validationResponse.ok) {
        throw new Error('Validation response was not ok');
      }

      const data = await validationResponse.json();
      
      // API'den gelen yanıtın geçerli olup olmadığını kontrol et
      if (!data || data.error || data.status === false) {
        console.error('Validation failed:', data?.message || data?.error || 'Invalid response');
        return null;
      }

      return data;
    } catch (error) {
      console.error('Kullanıcı doğrulama hatası:', error);
      return null;
    }
  });
};

export const fetchUserData = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        recaptcha: 'test',
        cark_obj_id: wheelId
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}user_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('User data response was not ok');
      }

      const result = await response.json();
      return result.data;
    } catch (error) {
      console.error('Kullanıcı bilgileri getirme hatası:', error);
      return null;
    }
  });
};

// Yeni bir fonksiyon: CSS config'i getir
export const fetchCssConfig = async () => {
  try {
    const response = await fetch(config.cssJsonUrl);
    if (!response.ok) {
      throw new Error('CSS config response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('CSS config getirme hatası:', error);
    return null;
  }
};

// Yeni bir fonksiyon: Çark datası getir
export const fetchWheelData = async () => {
  try {
    const response = await fetch(config.jsonUrl);
    if (!response.ok) {
      throw new Error('Wheel data response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Çark datası getirme hatası:', error);
    return null;
  }
};

// Çark segmentlerini getir
export const fetchSegments = async () => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        cark_obj_id: wheelId,
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}cark_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('Segments response was not ok');
      }

      const data = await response.json();
      return data.segments;
    } catch (error) {
      console.error('Çark segmentleri getirme hatası:', error);
      return null;
    }
  });
};

// Admin login fonksiyonu
export const adminLogin = async (username, password) => {
  try {
    let body = JSON.stringify({
      username,
      password
    });
    let keys = await window.rh.cr(body);
    const response = await fetch(`${config.adminApi}login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "hk": keys[0],
        "hh": keys[1]
      },
      credentials: 'include',
      body: body
    });

    const data = await response.json();

    // "Zaten oturumun açık" mesajı gelirse de başarılı kabul et
    if (data.message === "Zaten oturumun açık") {
      return {
        success: true,
        data: data,
        message: "Zaten oturumun açık!"
      };
    }

    // Normal hata kontrolü
    if (!response.ok || data.status === false) {
      throw new Error(data.message || 'Giriş başarısız');
    }

    return {
      success: true,
      data: data
    };
  } catch (error) {
    return {
      success: false,
      message: error.message || 'Giriş yapılırken bir hata oluştu'
    };
  }
};

// CSS değişikliklerini kaydetme fonksiyonu
export const saveCssChanges = async (cssData) => {
  try {
    const response = await fetch(`${config.adminApi}set_cark_css`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',

      body: JSON.stringify({
        data: {
          // Genel tasarım
          backgroundGradient1: cssData.backgroundGradient1,
          backgroundGradient2: cssData.backgroundGradient2,
          
          // Header tasarımı
          headerBg: cssData.headerBg,
          headerBorderColor: cssData.headerBorderColor,
          headerIconColor: cssData.headerIconColor,
          headerTextColor: cssData.headerTextColor,
          headerButtonBg: cssData.headerButtonBg,
          headerButtonHoverBg: cssData.headerButtonHoverBg,
          headerItemBg: cssData.headerItemBg,
          headerItemText: cssData.headerItemText,
          headerItemBorder: cssData.headerItemBorder,
          headerItemHoverBg: cssData.headerItemHoverBg,
          headerItemHoverBorder: cssData.headerItemHoverBorder,
          
          // Buton tasarımı
          buttonGradient1: cssData.buttonGradient1,
          buttonGradient2: cssData.buttonGradient2,
          buttonTextColor: cssData.buttonTextColor,
          buttonBorderColor: cssData.buttonBorderColor,
          buttonGlowColor: cssData.buttonGlowColor,
          buttonDisabled1: cssData.buttonDisabled1,
          buttonDisabled2: cssData.buttonDisabled2,
          buttonDisabledText: cssData.buttonDisabledText,
          buttonDisabledBorder: cssData.buttonDisabledBorder,
          
          // Çark tasarımı
          backgroundColor1: cssData.backgroundColor1,
          backgroundColor2: cssData.backgroundColor2,
          textColor1: cssData.textColor1,
          textColor2: cssData.textColor2,
          borderColor: cssData.borderColor,
          pointerColor: cssData.pointerColor,
          wheelGlowColor: cssData.wheelGlowColor,
          wheelGlowOpacity: cssData.wheelGlowOpacity,
          radiusLineColor: cssData.radiusLineColor,
          
          // Modal tasarımı (Tebrikler modalı)
          modalBg: cssData.modalBg,
          modalBorderColor: cssData.modalBorderColor,
          modalHeaderColor: cssData.modalHeaderColor,
          modalTextColor: cssData.modalTextColor,
          modalButtonGradient1: cssData.modalButtonGradient1,
          modalButtonGradient2: cssData.modalButtonGradient2,
          modalButtonText: cssData.modalButtonText,
          
          // Geçmiş modal tasarımı
          historyModalBg: cssData.historyModalBg,
          historyModalBorder: cssData.historyModalBorder,
          historyHeaderColor: cssData.historyHeaderColor,
          historyCloseColor: cssData.historyCloseColor,
          historyDateColor: cssData.historyDateColor,
          historyBadgeBg: cssData.historyBadgeBg,
          historyBadgeText: cssData.historyBadgeText,
          historyInfoLabel: cssData.historyInfoLabel,
          historyInfoValue: cssData.historyInfoValue,
          historyNoteColor: cssData.historyNoteColor,
          historyItemBg: cssData.historyItemBg,
          historyItemBorder: cssData.historyItemBorder,
          historyHeaderBg: cssData.historyHeaderBg,

          // Arkaplan görseli
          customBgEnabled: cssData.customBgEnabled ?? false,
          customBgImage: cssData.customBgImage ?? null,
        },
        cark_obj_id: wheelId
      })
    });

    if (!response.ok) {
      throw new Error('CSS kaydetme işlemi başarısız');
    }

    const result = await response.json();
    return {
      success: result.status,
      message: result.message
    };

  } catch (error) {
    console.error('CSS kaydetme hatası:', error);
    return {
      success: false,
      message: 'CSS değişiklikleri kaydedilirken bir hata oluştu'
    };
  }
};

// CSS verilerini getirmek için yeni fonksiyon
export const fetchCarkCss = async () => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        process_id: 'get-cark-css',
        user_id: wheelId,
        recaptcha: 'test'
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrlAdvanced}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('CSS verisi alınamadı');
      }

      const data = await response.json();
      
      if (!data || data.error || data.status === false) {
        throw new Error(data?.message || data?.error || 'Geçersiz CSS verisi');
      }

      return data;
    } catch (error) {
      console.error('CSS verisi getirme hatası:', error);
      return null;
    }
  });
};

// Default CSS'e dönme fonksiyonu
export const resetToDefaultCss = async () => {
  const defaultCss = {
    backgroundColor1: "#1A2234",
    backgroundColor2: "#2E4057",
    textColor1: "#E0E6ED",
    textColor2: "#09F984",
    borderColor: "#1A2234",
    pointerColor: "#09F984",
    wheelGlowColor: "#09F984",
    wheelGlowOpacity: 0.2,
    radiusLineColor: "#46868F",
    buttonGradient1: "#1A2234",
    buttonGradient2: "#2E4057",
    buttonTextColor: "#ffffff",
    buttonBorderColor: "#3B82F6",
    buttonGlowColor: "#3B82F6",
    buttonDisabled1: "#2a4a4d",
    buttonDisabled2: "#1F3C3F",
    buttonDisabledText: "#4a6a6d",
    buttonDisabledBorder: "#2a4a4d",
    headerBg: "rgba(30, 41, 59, 0.7)",
    headerBorderColor: "rgba(255, 255, 255, 0.1)",
    backgroundGradient1: "#0F172A",
    backgroundGradient2: "#1E293B",
    headerItemBg: "rgba(15, 23, 42, 0.6)",
    headerItemText: "#ffffff",
    headerItemBorder: "rgba(255, 255, 255, 0.1)",
    headerItemHoverBg: "rgba(15, 23, 42, 0.8)",
    headerItemHoverBorder: "rgba(9, 249, 132, 0.3)",
    headerEmojiColor: "#09F984",
    headerIconColor: "#09F984",
    headerTextColor: "#ffffff",
    headerButtonBg: "rgba(30, 41, 59, 0.7)",
    headerButtonHoverBg: "rgba(15, 23, 42, 0.8)",
    // Modal tasarımı (Tebrikler modalı)
    modalBg: "#1A2234",
    modalBorderColor: "#09F984",
    modalHeaderColor: "#FFFFFF",
    modalTextColor: "#E0E6ED",
    modalButtonGradient1: "#1A2234",
    modalButtonGradient2: "#2E4057",
    modalButtonText: "#FFFFFF",
    // Geçmiş modal tasarımı
    historyModalBg: "#1A2234",
    historyModalBorder: "#09F984",
    historyHeaderColor: "#FFFFFF",
    historyCloseColor: "#FFFFFF",
    historyDateColor: "#94A3B8",
    historyBadgeBg: "#09F984",
    historyBadgeText: "#1A2234",
    historyInfoLabel: "#94A3B8",
    historyInfoValue: "#E2E8F0",
    historyNoteColor: "#94A3B8",
    historyItemBg: "#2E4057",
    historyItemBorder: "#09F984",
    historyHeaderBg: "#1A2234"
  };

  try {
    const response = await fetch(`${config.adminApi}set_cark_css`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({
        data: defaultCss,
        cark_obj_id: wheelId
      })
    });

    const data = await response.json();

    if (!response.ok || data.status === false) {
      throw new Error(data.message || 'Varsayılan CSS ayarlarına dönülemedi');
    }

    return {
      success: true,
      message: 'Varsayılan CSS ayarlarına başarıyla dönüldü',
      data: defaultCss
    };
  } catch (error) {
    console.error('CSS sıfırlama hatası:', error);
    return {
      success: false,
      message: error.message || 'Varsayılan CSS ayarlarına dönülürken bir hata oluştu'
    };
  }
};

// Kullanıcı geçmişini getiren fonksiyon
export const fetchUserHistory = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        cark_obj_id: wheelId
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}user_gecmis`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('History response was not ok');
      }

      const result = await response.json();
      return result.data;
    } catch (error) {
      console.error('Kullanıcı geçmişi getirme hatası:', error);
      return null;
    }
  });
};

export const sendSpinCountRequest = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        process_id: bonusProcess,
        recaptcha: "test"
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl2}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('History response was not ok');
      }

      const result = await response.json();
      // Tüm API yanıtını döndür, sadece data kısmını değil
      return result;
    } catch (error) {
      console.error('Bonusİsteği Hatası:', error);
      return {
        status: false,
        message: 'Hak talep edilirken bir hata oluştu',
        data: null
      };
    }
  });
};

// Çarkı çevirmek için API isteği
export const spinWheel = async (userId) => {
  return ensureWheelIdLoaded(async () => {
    try {
      let body = JSON.stringify({
        user_id: userId,
        cark_obj_id: wheelId
      });
      let keys = await getKeys(body);
      const response = await fetch(`${config.apiBaseUrl}cevir`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "hk": keys[0],
          "hh": keys[1]
        },
        body: body
      });

      if (!response.ok) {
        throw new Error('Çark çevirme işlemi başarısız');
      }

      const result = await response.json();
      
      if (!result.status) {
        throw new Error(result.message || 'Çark çevirme işlemi başarısız');
      }

      return {
        success: true,
        prize: result.data.win,
        remainingSpins: result.data.spin_count
      };

    } catch (error) {
      console.error('Çark çevirme hatası:', error);
      return {
        success: false,
        message: error.message
      };
    }
  });
};
